import { defineMessages } from 'react-intl';

export default defineMessages({
  question: 'Pytanie',
  chooseAnswer: 'Wybierz odpowiedź',
  next: 'Dalej',
});
